import _ from 'underscore'

import React, { useEffect, useRef, useState } from 'react'

import styled from 'styled-components'

import Dropdown from 'components/Dropdown'
import Search from 'components/Search'
import Checkbox from 'components/Checkbox'

import { color } from 'styles/colors'
import CheckboxList from 'components/CheckboxList'

type Props = {
  isDropdownOpen: boolean
  onCloseDropdown: () => void
  options: Array<string>
  selectedFilterOptions: Array<string>
  onChangeFilterOptionsCallback: (selectedOptions: Array<string>) => void
  className?: string
}

const FilterDropdown = ({ isDropdownOpen, onCloseDropdown, options, selectedFilterOptions, onChangeFilterOptionsCallback, className = '' }: Props) => {
  const [inputValue, setInputValue] = useState('')
  const searchInputRef = useRef<HTMLInputElement>(null)

  const inputMatchedOptions = _.filter(options, option => option.toLowerCase().includes(inputValue?.toLowerCase()))

  const onChangeSelectAllCheckboxSelection = (checked: boolean) => {
    checked ? onChangeFilterOptionsCallback(options) : onChangeFilterOptionsCallback([])
  }

  useEffect(() => {
    searchInputRef.current?.focus()
  }, [searchInputRef, isDropdownOpen])

  return (
    <S.Dropdown isOpen={isDropdownOpen} onClose={onCloseDropdown} ariaLabelsToIgnoreOnOutsideClick={['filters']} {...{ className }}>
      <S.DropdownContent>
        <S.Search
          ariaLabel="search event names"
          placeholder="Search"
          ref={searchInputRef}
          value={inputValue}
          showClearIcon={_.isEmpty(inputValue)}
          onClickClearIcon={() => setInputValue('')}
          onChange={(newValue) => setInputValue(newValue)}
          onSearch={(newValue) => setInputValue(newValue)}
        />
        <Checkbox
          listId="event-filter-select-all"
          label="Select All"
          checked={
            selectedFilterOptions.length === 0
              ? false
              : selectedFilterOptions.length === options.length
                ? true
                : 'indeterminate'
          }
          onChange={(event) => onChangeSelectAllCheckboxSelection(event.target.checked)}
        />
        <CheckboxList
          items={_.map(inputMatchedOptions, (option) => ({ label: option, id: option }))}
          selectedIds={selectedFilterOptions}
          onSelectedIdsChange={(ids) => onChangeFilterOptionsCallback(ids)}
        />
      </S.DropdownContent>
    </S.Dropdown>
  )
}

export default FilterDropdown

const S = {
  Dropdown: styled(Dropdown)`
    background: ${color('paneBackground')};
  `,
  DropdownContent: styled.div`
    padding: 5px;
    max-height: 400px;
    overflow-y: scroll;
  `,
  Search: styled(Search)<{ ariaLabel: string, placeholder: string, value: string, showClearIcon: boolean,
    onClickClearIcon: () => void, onChange: (newValue: string) => void, onSearch: (value: string) => void }>`
    display: inline-block;
    width: 270px;

    & > button:last-of-type {
      display: none;
    }
  `
}
